import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { SharedMaterialUIModule } from '@shared/modules/shared-material-ui.module';
import { InterventionListItemResponse } from '../../../intervention.model';
import {
  DataTableColumn,
  DataTableComponent,
  DataTablePageChangedEvent,
} from '@shared/components/data-table.component';
import { ActionMenu } from "@shared/components/action-menu/action-menu";
import { useInterventionActionMenu } from "./intervention-action-menu-composable";

@Component({
  selector: 'intervention-table',
  imports: [DataTableComponent, ActionMenu, ...SharedMaterialUIModule],
  templateUrl: './intervention-table.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class InterventionTableComponent {
  protected readonly columns: DataTableColumn<InterventionListItemResponse>[] = [
    {
      id: 'interventionNumber',
      header: 'Intervention number',
      value: (item) => item.interventionNumber,
      cellClass: 'px-3 py-3 font-medium text-slate-900',
    },
    {
      id: 'interventionTypeName',
      header: 'Type',
      value: (item) => item.interventionTypeName,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'owner',
      header: 'Owner',
      value: (item) => (item.ownerName ? (item.ownerDependantId ? `${item.ownerName} (dependant)` : item.ownerName) : '—'),
      cellClass: 'px-3 py-3',
    },
    {
      id: 'customer',
      header: 'Customer',
      value: (item) => item.customer ?? '—',
      cellClass: 'px-3 py-3',
    },
    {
      id: 'status',
      header: 'Status',
      value: (item) => item.status,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'createdDate',
      header: 'Created',
      value: (item) => item.createdDate.slice(0, 10),
      cellClass: 'px-3 py-3',
    },
    {
      id: 'startDate',
      header: 'Start date',
      value: (item) => item.startDate,
      cellClass: 'px-3 py-3',
    },
    {
      id: 'isActive',
      header: 'Active',
      value: (item) => (item.isActive ? 'Active' : 'Inactive'),
      cellClass: 'px-3 py-3',
    },
  ];
  readonly interventions = input<InterventionListItemResponse[]>([]);
  readonly loading = input(false);
  readonly searchTerm = input('');
  readonly pageNumber = input(1);
  readonly pageSize = input(25);
  readonly totalCount = input(0);
  readonly totalPages = input(0);
  readonly refreshed = output<void>();
  readonly searchChanged = output<string>();
  readonly pageChanged = output<DataTablePageChangedEvent>();
  readonly actionMenuItems = useInterventionActionMenu().interventionActionMenuItems;
}
